/* LMM predictive layout is rendered inline from snippets/lmm-bestseller-sort-inline.liquid. */
window.LMMPredictiveSplitLayoutAssetStub='2026.07.11-bestseller-2';
